import React, {Component} from 'react';

class MobileHeader extends Component {
  constructor(props) {
    super(props)
    this.state = {

    }
  }

  showMenu = () => {
    console.log('click')
    this.setState({})
  }

  render() {
    return(
      <nav className="mobile-navigation">
        <i className="fa fa-bars fa-2x" aria-hidden="true" onClick={() => this.showMenu()}>
          <ul className="sub-menu">
            <a href="https://www.pasarpolis.com/asuransi/kesehatan">Asuransi Kesehatan</a>
            <a href="https://www.pasarpolis.com/asuransi/kendaraan">Asuransi Kendaraan</a>
            <a href="https://www.pasarpolis.com/asuransi/kecelakaan">Asuransi Kecelakaan</a>
            <a href="https://www.pasarpolis.com/asuransi/properti">Asuransi Properti</a>
            <a href="https://www.pasarpolis.com/asuransi/jiwa">Asuransi Jiwa</a>
            <a href="https://www.pasarpolis.com/asuransi/perjalanan">Asuransi Perjalanan</a>
          </ul>
        </i>
      </nav>
    )
  }
}

export default MobileHeader;



// WEBPACK FOOTER //
// ./src/component/Common/header/mobile_header.js